import { DefaultContext, EventObject, MachineConfig, StateSchema } from 'xstate/es';

import { BuildingReviewLandingAutocompleteStatechartEvent } from 'common/module/building-review-landing/autocomplete/statechart.event';
import { BuildingReviewLandingAutocompleteStatechartActionEnum } from 'common/module/building-review-landing/autocomplete/statechart/action.enum';
import { BuildingReviewLandingAutocompleteStatechartStateEnum } from 'common/module/building-review-landing/autocomplete/statechart/state.enum';

export const BuildingReviewLandingAutocompleteStatechart: MachineConfig<DefaultContext, StateSchema, EventObject> = {
  initial: BuildingReviewLandingAutocompleteStatechartStateEnum.idle,
  states: {
    [BuildingReviewLandingAutocompleteStatechartStateEnum.idle]: {
      on: {
        [BuildingReviewLandingAutocompleteStatechartEvent.typing]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.fetchingListItems,
          actions: [BuildingReviewLandingAutocompleteStatechartActionEnum.hideListItems],
        },
        [BuildingReviewLandingAutocompleteStatechartEvent.selectedListItem]:
          BuildingReviewLandingAutocompleteStatechartStateEnum.listItemSelected,
        [BuildingReviewLandingAutocompleteStatechartEvent.clearedAutocomplete]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.idle,
          actions: [BuildingReviewLandingAutocompleteStatechartActionEnum.hideListItems],
        },
      },
    },
    [BuildingReviewLandingAutocompleteStatechartStateEnum.fetchingListItems]: {
      entry: [
        BuildingReviewLandingAutocompleteStatechartActionEnum.fetchListItems,
        BuildingReviewLandingAutocompleteStatechartActionEnum.showLoader,
      ],
      on: {
        [BuildingReviewLandingAutocompleteStatechartEvent.fetchListItemsSucceeded]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.checkingIfHasListItems,
          actions: [
            BuildingReviewLandingAutocompleteStatechartActionEnum.updateListItems,
            BuildingReviewLandingAutocompleteStatechartActionEnum.hideLoader,
          ],
        },
        [BuildingReviewLandingAutocompleteStatechartEvent.typing]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.fetchingListItems,
          actions: [
            BuildingReviewLandingAutocompleteStatechartActionEnum.cancelCurrentFetch,
            BuildingReviewLandingAutocompleteStatechartActionEnum.hideListItems,
          ],
        },
      },
    },
    [BuildingReviewLandingAutocompleteStatechartStateEnum.checkingIfHasListItems]: {
      onEntry: [BuildingReviewLandingAutocompleteStatechartActionEnum.checkIfHasListItems],
      on: {
        [BuildingReviewLandingAutocompleteStatechartEvent.hasListItems]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.idle,
          actions: [BuildingReviewLandingAutocompleteStatechartActionEnum.showListItems],
        },
        [BuildingReviewLandingAutocompleteStatechartEvent.hasNoListItems]: {
          target: [BuildingReviewLandingAutocompleteStatechartStateEnum.idle],
          actions: [BuildingReviewLandingAutocompleteStatechartActionEnum.hideListItems],
        },
      },
    },
    [BuildingReviewLandingAutocompleteStatechartStateEnum.listItemSelected]: {
      onEntry: [BuildingReviewLandingAutocompleteStatechartActionEnum.updateFormField],
      on: {
        [BuildingReviewLandingAutocompleteStatechartEvent.typing]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.fetchingListItems,
          actions: [BuildingReviewLandingAutocompleteStatechartActionEnum.resetSelection],
        },
        [BuildingReviewLandingAutocompleteStatechartEvent.selectedListItem]:
          BuildingReviewLandingAutocompleteStatechartStateEnum.listItemSelected,
        [BuildingReviewLandingAutocompleteStatechartEvent.clearedAutocomplete]: {
          target: BuildingReviewLandingAutocompleteStatechartStateEnum.idle,
          actions: [BuildingReviewLandingAutocompleteStatechartActionEnum.resetSelection],
        },
      },
    },
  },
};
